import { render } from "./LayoutComponent.vue?vue&type=template&id=725e51b6"
import script from "./LayoutComponent.vue?vue&type=script&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&lang=js"

import "./LayoutComponent.vue?vue&type=style&index=0&id=725e51b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__